module.exports = __webpack_public_path__ + "media/assets/img/oferte-active-a143284a1199bd7b62297c51f7be2421.svg";